import IconRadio from './IconRadio';

export default IconRadio;
